import api from '../../services/api.js';

/** In-app notifications client (the navbar bell, Episodes Plan 2 Task 12). */
const notificationService = {
  listUnread: () => api.request('/notifications?unread=1'),
  markRead: (ids) => api.request('/notifications/read', { method: 'POST', body: { ids } }),
};
export default notificationService;
